var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericIFrame',{attrs:{"dashboardId":this.$store.getters.getCurrentDashboardId}})}
var staticRenderFns = []

export { render, staticRenderFns }